import React, { createContext, useContext, useState } from 'react';
import { createPortal } from 'react-dom';
import { useIsMobile } from '../hooks/use-mobile';
import { shouldShowHeaderCreateActions } from '../utils/header-create-actions';

type SetHeaderPageActionsSlot = (element: HTMLElement | null) => void;

const HeaderPageActionsSlotStateContext = createContext<HTMLElement | null>(null);
const HeaderPageActionsSlotSetContext = createContext<SetHeaderPageActionsSlot>(() => {});

export const HEADER_PAGE_ACTIONS_TEST_ID = 'header-page-actions';

export const HeaderPageActionsProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [slot, setSlot] = useState<HTMLElement | null>(null);

  return (
    <HeaderPageActionsSlotSetContext.Provider value={setSlot}>
      <HeaderPageActionsSlotStateContext.Provider value={slot}>
        {children}
      </HeaderPageActionsSlotStateContext.Provider>
    </HeaderPageActionsSlotSetContext.Provider>
  );
};

export const HeaderPageActionsSlot: React.FC<{
  className?: string;
  children?: React.ReactNode;
  onSlotElement?: (element: HTMLDivElement | null) => void;
}> = ({ className, children, onSlotElement }) => {
  const setSlot = useContext(HeaderPageActionsSlotSetContext);

  return (
    <div
      ref={(element) => {
        setSlot(element);
        onSlotElement?.(element);
      }}
      data-testid={HEADER_PAGE_ACTIONS_TEST_ID}
      className={className}
    >
      {children}
    </div>
  );
};

export const HeaderPageActions: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const slot = useContext(HeaderPageActionsSlotStateContext);
  if (!slot) {
    return null;
  }
  return createPortal(children, slot);
};

export const HeaderCreateActions: React.FC<{
  hasItems: boolean;
  children: React.ReactNode;
}> = ({ hasItems, children }) => {
  const isMobile = useIsMobile();
  if (!shouldShowHeaderCreateActions(hasItems, isMobile)) {
    return null;
  }
  return <HeaderPageActions>{children}</HeaderPageActions>;
};
